import { ReactComponent as Anschlussanfrage } from "../assets/svg/Erzeugungsanlagen/Anschlussanfrage.svg";
import { ReactComponent as Direktvermarktung } from "../assets/svg/Erzeugungsanlagen/Direktvermarktung.svg";
import { ReactComponent as Selbstverbrauch } from "../assets/svg/Erzeugungsanlagen/Selbstverbrauch.svg";
import { ReactComponent as Einspeiseanfrage } from "../assets/svg/Erzeugungsanlagen/Einspeiseanfrage.svg";
import { ReactComponent as Netzanschlussmonitor } from "../assets/svg/Erzeugungsanlagen/Netzanschlussmonitor.svg";
import { ReactComponent as Redispatch2 } from "../assets/svg/Erzeugungsanlagen/Redispatch2.svg";
import "./components.scss";
import Card from "../assets/card/card";
import { PopupForms, Metalink } from "../assets/PopupForms/PopupForms";
import "./popupPosition.scss";
import "../assets/svg/animationSVG/animationErzeugungsanlagen.scss"
import "../assets/svg/animationSVG/animationRedispatch.scss"

export function ErzeugungsanlagenPrivateCards(props: {text: any}) {
  return <>
      <Card
        topicSVG={<Anschlussanfrage />}
        headline={props.text.Erzeugungsanlagen.Anschlussanfrage.headline}
        text={props.text.Erzeugungsanlagen.Anschlussanfrage.text}
        buttonFunction={() => {window.open(props.text.Erzeugungsanlagen.Anschlussanfrage.link,'_self')}}
        item="item-1"
      />
      <Card
        topicSVG={<Direktvermarktung />}
        headline={props.text.Erzeugungsanlagen.Direktvermarktung.headline}
        text={props.text.Erzeugungsanlagen.Direktvermarktung.text}
        buttonFunction={() => {window.open(props.text.Erzeugungsanlagen.Direktvermarktung.link,'_self')}}
        item="item-2"
      />
      <Card
        topicSVG={<Selbstverbrauch />}
        headline={props.text.Erzeugungsanlagen.Selbstverbrauch.headline}
        text={props.text.Erzeugungsanlagen.Selbstverbrauch.text}
        buttonFunction={() => {window.open(props.text.Erzeugungsanlagen.Selbstverbrauch.link,'_self')}}
        item="item-3"
      />
</>
}

export function ErzeugungsanlagenBusinessCards(props: {text: any}) {
  return <>
      <Card
        topicSVG={<Einspeiseanfrage />}
        headline={props.text.Erzeugungsanlagen.Einspeiseanfrage.headline}
        text={props.text.Erzeugungsanlagen.Einspeiseanfrage.text}
        buttonFunction={() => {window.open(props.text.Erzeugungsanlagen.Einspeiseanfrage.link,'_self')}}
        item="item-1"
      />
      <Card
        topicSVG={<Netzanschlussmonitor />}
        headline={props.text.Erzeugungsanlagen.Netzanschlussmonitor.headline}
        text={props.text.Erzeugungsanlagen.Netzanschlussmonitor.text}
        buttonFunction={() => {window.open(props.text.Erzeugungsanlagen.Netzanschlussmonitor.link,'_self')}}
        item="item-2"
      />
      <Card
        topicSVG={<Redispatch2/>}
        headline={props.text.Erzeugungsanlagen.Redispatch.headline}
        text={props.text.Erzeugungsanlagen.Redispatch.text}
        buttonFunction={() => {window.open(props.text.Erzeugungsanlagen.Redispatch.link,'_self')}}
        item="item-3"
      />
</>
}

export function ErzeugungsanlagenPopupContainer (props: {setPopupState: Function, text: any}) {
  return(
    <PopupForms
      buttonSecondaryFunction={() => {props.setPopupState()}}
    >
      <>
        <Metalink linkText="Formulare" function={() => {window.open(props.text.Erzeugungsanlagen.Mehr.Formulare,'_self')}}/>
        <Metalink linkText="Recht & Technik" function={() => {window.open(props.text.Erzeugungsanlagen.Mehr.RechtUndTechnik,'_self')}} />
        <Metalink linkText="Vergütung" function={() => {window.open(props.text.Erzeugungsanlagen.Mehr.Verguetung,'_self')}} />
      </>
    </PopupForms>

  )
}

export function ErzeugungsanlagenBusinessPopupContainer (props: {setPopupState: Function, text: any}) {
  return(
    <PopupForms
      buttonSecondaryFunction={() => {props.setPopupState()}}
    >
      <>
        <Metalink linkText="Formulare" function={() => {window.open(props.text.Erzeugungsanlagen.Mehr_business.Formulare,'_self')}}/>
        <Metalink linkText="Recht & Technik" function={() => {window.open(props.text.Erzeugungsanlagen.Mehr_business.RechtUndTechnik,'_self')}} />
        <Metalink linkText="Vergütung" function={() => {window.open(props.text.Erzeugungsanlagen.Mehr_business.Verguetung,'_self')}} />
      </>
    </PopupForms>

  )
}